import { Error } from '@mui/icons-material'
import { Box, Paper, Stack, SvgIcon, Typography } from '@mui/material'

import libbyPeekingSrc from '~/assets/images/libby/libby-peeking.webp'
import useIsPartner from '~/features/partners/hooks/useIsPartner'

type TProps = {
  message: string
}

function NotFound({ message }: TProps) {
  const isPartner = useIsPartner()

  return (
    <Stack sx={{ alignItems: 'center' }}>
      <Box
        sx={
          isPartner
            ? {}
            : {
                backgroundImage: `url(${libbyPeekingSrc})`,
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'contain',
                width: 100,
                height: 100,
                position: 'relative',
                top: 40,
              }
        }
      />
      <Paper elevation={12}>
        <Stack spacing={2} sx={{ padding: 2, alignItems: 'center' }}>
          <SvgIcon sx={{ color: (theme) => theme.palette.secondary1 }}>
            <Error />
          </SvgIcon>
          <Typography variant="h6" align="center">
            {message}
          </Typography>
          <Typography variant="body1" align="center">
            Please make sure you are signed into the right Account.
          </Typography>
        </Stack>
      </Paper>
    </Stack>
  )
}

export default NotFound
